<template>
    <select
        v-bind:value="value"
        v-on:input="$emit('input', $event.target.value)"
        v-on:blur="$emit('filled-out', $event.target.value)"
    >
        <option value="" disabled selected hidden>
            {{field.placeholder ? field.placeholder : "Please select value"}}
        </option>
        <option
            v-for="option in field.options"
            :key="option.id"
            :value="option.value"
        >
            {{option.label}}
        </option>
    </select>
</template>

<script>
export default {
  props: {
    field: Object,
    value: ""
  }
};
</script>
